export const getRequiredMessage = (label: string) => `Voer een ${label} in`.toLowerCase();
